const DUPLICATE_FORM_STORAGE_KEY = 'addBaseStationDuplicateForm';

export const saveDuplicateBaseStationTemplate = data => {
	sessionStorage.setItem(DUPLICATE_FORM_STORAGE_KEY, JSON.stringify(data));
};

export const readDuplicateBaseStationTemplate = () => {
	const rawData = sessionStorage.getItem(DUPLICATE_FORM_STORAGE_KEY);
	if (typeof rawData !== 'string' || rawData.length === 0) {
		return null;
	}
	sessionStorage.removeItem(DUPLICATE_FORM_STORAGE_KEY);
	try {
		return JSON.parse(rawData);
	} catch (error) {
		console.log('failed to parse duplicate base station data', error);
		return null;
	}
};
